module.exports = "<h1>TODO 500 SERVER ERROR</h1>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/500/500.component.html
// module id = ./src/app/pages/500/500.component.html
// module chunks = main